import { Box, Typography } from "@mui/material";
import { DefaultUrlWeb } from "config/Configuration";

export default function WrapperAmount({ data }) {
  return (
    <Box display="flex" alignItems="center">
      <img src={DefaultUrlWeb + data?.coinImageUrl} alt="" width={25} />
      <Typography variant="h5" color="text.main" pl={1}>
        {data?.coinName}
      </Typography>
    </Box>
  );
}
